export const conferenceMenu = [
  { name: "Home", path: "/" },
  { name: "Committees", path: "/landingpage/committees" },
  { name: "Call for Papers", path: "/landingpage/call-for-paper" },
  { name: "Important Dates", path: "/landingpage/important-dates" },
  { name: "Submission", path: "/landingpage/submission" },
  { name: "Registration", path: "/landingpage/registration" },
  { name: "Contact Us", path: "/landingpage/contact" },
  { name: "Downloads", path: "/landingpage/downloads" },
];
